import { verifyGiftCard } from './verify-gift-card';
import { redeemGiftCard } from './redeem-gift-card';
import { getGateways } from './v2/get-gateways';
import { getBanks } from './v2/get-banks';
import { getCurrencies } from './v2/get-currencies';
import { confirmDirectDebit } from './v2/confirm-direct-debit';

export const paymentsSDK = {
    giftCards: {
        verify: verifyGiftCard,
        redeem: redeemGiftCard,
    },
    v2: {
        gateways: {
            getMany: getGateways,
        },
        banks: {
            getMany: getBanks,
        },
        currencies: {
            getMany: getCurrencies,
        },
        payments: {
            confirmDirectDebit,
        },
    },
};
